<div class="card">
    <div class="sensor-params">
        <div class="input-group col100">
            <label for="averageRoomTemperature">Mittlere Wohnraumtemperatur in °C*</label>
            <ng-container *ngIf="!areChecksOptional()">
                <div [ngClass]="{'has-error':showError(averageRoomTemperature)}">
                    <input name="averageRoomTemperature"
                           id="averageRoomTemperatureRequired"
                           type="number"
                           required
                           [(ngModel)]="model.averageRoomTemperature"
                           #averageRoomTemperature="ngModel"
                           placeholder="Mittlere Wohnraumtemperatur in °C*"
                           #dynamicInput="ngModel"/>
                </div>
                <div class="error"><span *ngIf="showError(averageRoomTemperature)">"Mittlere Wohnraumtemperatur in °C" ist ein Pflichtfeld.</span>
                </div>
            </ng-container>
            <ng-container *ngIf="areChecksOptional()">
                <div [ngClass]="{'has-error':showError(averageRoomTemperature)}">
                    <input name="averageRoomTemperature"
                           id="averageRoomTemperature"
                           type="number"
                           [(ngModel)]="model.averageRoomTemperature"
                           #averageRoomTemperature="ngModel"
                           placeholder="Mittlere Wohnraumtemperatur in °C*"
                           #dynamicInput="ngModel"/>
                </div>
                <div class="error"><span *ngIf="showError(averageRoomTemperature)">"Mittlere Wohnraumtemperatur in °C" ist ein Pflichtfeld.</span>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="check-box-input-group">
        <div class="input-group">
            <label>Existiert bereits ein Auẞentemperaturfühler?*</label>
            <div *ngIf="!areChecksOptional()" class="radio-wrapper">
                <div class="radio-line">
                    <input type="radio" [value]="true" id="outdoorTemperatureAvailableRequiredTrue"
                           name="outdoorTemperatureAvailable"
                           required
                           [(ngModel)]="model.outdoorTemperatureAvailable" #outdoorTemperatureAvailable="ngModel">
                    <label class="radio-label" for="outdoorTemperatureAvailableRequiredTrue">Ja</label>
                </div>
                <div class="radio-line">
                    <input type="radio" [value]="false" id="outdoorTemperatureAvailableRequiredFalse"
                           name="outdoorTemperatureAvailable"
                           required
                           [(ngModel)]="model.outdoorTemperatureAvailable" #outdoorTemperatureAvailable="ngModel">
                    <label class="radio-label" for="outdoorTemperatureAvailableRequiredFalse">Nein</label>
                </div>
                <div class="error">
                    <span *ngIf="showAnyError(outdoorTemperatureAvailable)">Es ist ein Pflichtfeld.</span>
                </div>
            </div>
            <div *ngIf="areChecksOptional()" class="radio-wrapper">
                <div class="radio-line">
                    <input type="radio" [value]="true" id="outdoorTemperatureAvailableTrue"
                           name="outdoorTemperatureAvailable"
                           [(ngModel)]="model.outdoorTemperatureAvailable" #outdoorTemperatureAvailable="ngModel">
                    <label class="radio-label" for="outdoorTemperatureAvailableTrue">Ja</label>
                </div>
                <div class="radio-line">
                    <input type="radio" [value]="false" id="outdoorTemperatureAvailableFalse"
                           name="outdoorTemperatureAvailable"
                           [(ngModel)]="model.outdoorTemperatureAvailable" #outdoorTemperatureAvailable="ngModel">
                    <label class="radio-label" for="outdoorTemperatureAvailableFalse">Nein</label>
                </div>
                <div class="radio-line">
                    <input type="radio" [value]="null" id="outdoorTemperatureAvailableUnknown"
                           name="outdoorTemperatureAvailable"
                           [(ngModel)]="model.outdoorTemperatureAvailable" #outdoorTemperatureAvailable="ngModel">
                    <label class="radio-label" for="outdoorTemperatureAvailableUnknown">Unbekannt</label>
                </div>
                <div class="error">
                    <span *ngIf="showAnyError(outdoorTemperatureAvailable)">Es ist ein Pflichtfeld.</span>
                </div>
            </div>
        </div>
    </div>

    <div class="check-box-input-group">
        <div class="input-group">
            <label>Ist Sommer- / Winterbetrieb möglich?*</label>
            <div *ngIf="!areChecksOptional()" class="radio-wrapper">
                <div class="radio-line">
                    <input type="radio" [value]="true" id="summerWinterOperationAvailableRequiredTrue"
                           name="summerWinterOperationAvailable"
                           required
                           [(ngModel)]="model.summerWinterOperationAvailable" #summerWinterOperationAvailable="ngModel">
                    <label class="radio-label" for="summerWinterOperationAvailableRequiredTrue">Ja</label>
                </div>
                <div class="radio-line">
                    <input type="radio" [value]="false" id="summerWinterOperationAvailableRequiredFalse"
                           name="summerWinterOperationAvailable"
                           required
                           [(ngModel)]="model.summerWinterOperationAvailable" #summerWinterOperationAvailable="ngModel">
                    <label class="radio-label" for="summerWinterOperationAvailableRequiredFalse">Nein</label>
                </div>
                <div class="error">
                    <span *ngIf="showAnyError(summerWinterOperationAvailable)">Es ist ein Pflichtfeld.</span>
                </div>
            </div>
            <div *ngIf="areChecksOptional()" class="radio-wrapper">
                <div class="radio-line">
                    <input type="radio" [value]="true" id="summerWinterOperationAvailableTrue"
                           name="summerWinterOperationAvailable"
                           [(ngModel)]="model.summerWinterOperationAvailable" #summerWinterOperationAvailable="ngModel">
                    <label class="radio-label" for="summerWinterOperationAvailableTrue">Ja</label>
                </div>
                <div class="radio-line">
                    <input type="radio" [value]="false" id="summerWinterOperationAvailableFalse"
                           name="summerWinterOperationAvailable"
                           [(ngModel)]="model.summerWinterOperationAvailable" #summerWinterOperationAvailable="ngModel">
                    <label class="radio-label" for="summerWinterOperationAvailableFalse">Nein</label>
                </div>
                <div class="radio-line">
                    <input type="radio" [value]="null" id="summerWinterOperationAvailableUnknown"
                           name="summerWinterOperationAvailable"
                           [(ngModel)]="model.summerWinterOperationAvailable" #summerWinterOperationAvailable="ngModel">
                    <label class="radio-label" for="summerWinterOperationAvailableUnknown">Unbekannt</label>
                </div>
                <div class="error">
                    <span *ngIf="showAnyError(summerWinterOperationAvailable)">Es ist ein Pflichtfeld.</span>
                </div>
            </div>
        </div>
    </div>

    <div class="check-box-input-group">
        <div class="input-group">
            <label>Ist ein Notausschalter vorhanden?*</label>
            <div *ngIf="!areChecksOptional()" class="radio-wrapper">
                <div class="radio-line">
                    <input type="radio" [value]="true" id="emergencyStopAvailableRequiredTrue"
                           name="emergencyStopAvailable"
                           required
                           [(ngModel)]="model.emergencyStopAvailable" #emergencyStopAvailable="ngModel">
                    <label class="radio-label" for="emergencyStopAvailableRequiredTrue">Ja</label>
                </div>
                <div class="radio-line">
                    <input type="radio" [value]="false" id="emergencyStopAvailableRequiredFalse"
                           name="emergencyStopAvailable"
                           required
                           [(ngModel)]="model.emergencyStopAvailable" #emergencyStopAvailable="ngModel">
                    <label class="radio-label" for="emergencyStopAvailableRequiredFalse">Nein</label>
                </div>
                <div class="error">
                    <span *ngIf="showAnyError(emergencyStopAvailable)">Es ist ein Pflichtfeld.</span>
                </div>
            </div>
            <div *ngIf="areChecksOptional()" class="radio-wrapper">
                <div class="radio-line">
                    <input type="radio" [value]="true" id="emergencyStopAvailableTrue" name="emergencyStopAvailable"
                           [(ngModel)]="model.emergencyStopAvailable" #emergencyStopAvailable="ngModel">
                    <label class="radio-label" for="emergencyStopAvailableTrue">Ja</label>
                </div>
                <div class="radio-line">
                    <input type="radio" [value]="false" id="emergencyStopAvailableFalse" name="emergencyStopAvailable"
                           [(ngModel)]="model.emergencyStopAvailable" #emergencyStopAvailable="ngModel">
                    <label class="radio-label" for="emergencyStopAvailableFalse">Nein</label>
                </div>
                <div class="radio-line">
                    <input type="radio" [value]="null" id="emergencyStopAvailableUnknown" name="emergencyStopAvailable"
                           [(ngModel)]="model.emergencyStopAvailable" #emergencyStopAvailable="ngModel">
                    <label class="radio-label" for="emergencyStopAvailableUnknown">Unbekannt</label>
                </div>
                <div class="error">
                    <span *ngIf="showAnyError(emergencyStopAvailable)">Es ist ein Pflichtfeld.</span>
                </div>
            </div>
        </div>
    </div>

    <div class="check-box-input-group">
        <div class="input-group">
            <label>Sind die Rohrleitungen gedämmt?*</label>
            <div *ngIf="!areChecksOptional()" class="radio-wrapper">
                <div class="radio-line">
                    <input type="radio" [value]="true" id="insulatedPipesRequiredTrue" name="insulatedPipes"
                           required
                           [(ngModel)]="model.insulatedPipes" #insulatedPipes="ngModel">
                    <label class="radio-label" for="insulatedPipesRequiredTrue">Ja</label>
                </div>
                <div class="radio-line">
                    <input type="radio" [value]="false" id="insulatedPipesRequiredFalse" name="insulatedPipes"
                           required
                           [(ngModel)]="model.insulatedPipes" #insulatedPipes="ngModel">
                    <label class="radio-label" for="insulatedPipesRequiredFalse">Nein</label>
                </div>
                <div class="error">
                    <span *ngIf="showAnyError(insulatedPipes)">Es ist ein Pflichtfeld.</span>
                </div>
            </div>
            <div *ngIf="areChecksOptional()" class="radio-wrapper">
                <div class="radio-line">
                    <input type="radio" [value]="true" id="insulatedPipesTrue" name="insulatedPipes"
                           [(ngModel)]="model.insulatedPipes" #insulatedPipes="ngModel">
                    <label class="radio-label" for="insulatedPipesTrue">Ja</label>
                </div>
                <div class="radio-line">
                    <input type="radio" [value]="false" id="insulatedPipesFalse" name="insulatedPipes"
                           [(ngModel)]="model.insulatedPipes" #insulatedPipes="ngModel">
                    <label class="radio-label" for="insulatedPipesFalse">Nein</label>
                </div>
                <div class="radio-line">
                    <input type="radio" [value]="null" id="insulatedPipesUnknown" name="insulatedPipes"
                           [(ngModel)]="model.insulatedPipes" #insulatedPipes="ngModel">
                    <label class="radio-label" for="insulatedPipesUnknown">Unbekannt</label>
                </div>
                <div class="error">
                    <span *ngIf="showAnyError(insulatedPipes)">Es ist ein Pflichtfeld.</span>
                </div>
            </div>
        </div>
    </div>

    <div class="check-box-input-group">
        <div class="input-group">
            <label>Sind Dämmkappen auf den Armaturen?*</label>
            <div *ngIf="!areChecksOptional()" class="radio-wrapper">
                <div class="radio-line">
                    <input type="radio" [value]="true" id="insulatingCapsRequiredTrue" name="insulatingCaps"
                           required
                           [(ngModel)]="model.insulatingCaps" #insulatingCaps="ngModel">
                    <label class="radio-label" for="insulatingCapsRequiredTrue">Ja</label>
                </div>
                <div class="radio-line">
                    <input type="radio" [value]="false" id="insulatingCapsRequiredFalse" name="insulatingCaps"
                           required
                           [(ngModel)]="model.insulatingCaps" #insulatingCaps="ngModel">
                    <label class="radio-label" for="insulatingCapsRequiredFalse">Nein</label>
                </div>
                <div class="error">
                    <span *ngIf="showAnyError(insulatingCaps)">Es ist ein Pflichtfeld.</span>
                </div>
            </div>
            <div *ngIf="areChecksOptional()" class="radio-wrapper">
                <div class="radio-line">
                    <input type="radio" [value]="true" id="insulatingCapsTrue" name="insulatingCaps"
                           [(ngModel)]="model.insulatingCaps" #insulatingCaps="ngModel">
                    <label class="radio-label" for="insulatingCapsTrue">Ja</label>
                </div>
                <div class="radio-line">
                    <input type="radio" [value]="false" id="insulatingCapsFalse" name="insulatingCaps"
                           [(ngModel)]="model.insulatingCaps" #insulatingCaps="ngModel">
                    <label class="radio-label" for="insulatingCapsFalse">Nein</label>
                </div>
                <div class="radio-line">
                    <input type="radio" [value]="null" id="insulatingCapsUnknown" name="insulatingCaps"
                           [(ngModel)]="model.insulatingCaps" #insulatingCaps="ngModel">
                    <label class="radio-label" for="insulatingCapsUnknown">Unbekannt</label>
                </div>
                <div class="error">
                    <span *ngIf="showAnyError(insulatingCaps)">Es ist ein Pflichtfeld.</span>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="field">Pflichtfelder*</div>
<app-navigation-footer
        [isBackLinkDisabled]="false"
        [backLink]="'/gateway/heating/information'"
        [isNextLinkDisabled]="!validationService.isHeatingCheckValid(model)"
        [nextLink]="'/gateway/sensors/temperature'"
        [isLast]="false"
></app-navigation-footer>
